jQuery(function () {
  if (document.body.classList.contains("block-editor-page")) return;

  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) {
      wp.domReady(cb);
    } else {
      cb();
    }
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;

    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };

    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initPlasmaTimeline();
      });
    });
  });

  function initPlasmaTimeline() {
    const blocks = document.querySelectorAll(".js-pt");
    if (!blocks.length) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      const items = block.querySelectorAll(".js-pt-item");
      const rows = Array.from(block.querySelectorAll(".js-pt-row"));

      if (!rows.length) return;

      if (items.length) {
        if (reduceMotion) {
          gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        } else {
          gsap.set(items, { autoAlpha: 0, y: 24 });

          const vars = {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: "power3.out",
            stagger: 0.08,
            clearProps: "transform",
          };

          if (ScrollTrigger) {
            vars.scrollTrigger = {
              trigger: block,
              start: "top 78%",
              once: true,
              invalidateOnRefresh: true,
            };
          }

          gsap.to(items, vars);
        }
      }

      if (reduceMotion || !ScrollTrigger) {
        rows.forEach((row) => row.classList.add("is-filled"));
        return;
      }

      let currentRow = null;
      let currentDot = null;
      let currentPulseTween = null;
      let currentRingTween = null;

      const stopCurrentPulse = () => {
        if (currentPulseTween) {
          currentPulseTween.kill();
          currentPulseTween = null;
        }

        if (currentRingTween) {
          currentRingTween.kill();
          currentRingTween = null;
        }

        if (currentRow) {
          currentRow.classList.remove("is-current");
        }

        if (currentDot) {
          gsap.set(currentDot, {
            scale: 1,
            boxShadow: "0 0 0 0 rgba(251,245,232,0)",
            clearProps: "transform",
          });
        }

        currentRow = null;
        currentDot = null;
      };

      const activateRow = (row) => {
        const dot = row.querySelector(".pt__dot");
        if (!dot) return;

        row.classList.add("is-filled");

        if (currentRow === row) return;

        stopCurrentPulse();

        currentRow = row;
        currentDot = dot;
        currentRow.classList.add("is-current");

        currentPulseTween = gsap.to(dot, {
          scale: 1.7,
          duration: 0.7,
          ease: "power1.inOut",
          repeat: -1,
          yoyo: true,
        });

        currentRingTween = gsap.to(dot, {
          boxShadow: "0 0 0 12px rgba(251,245,232,0)",
          duration: 0.7,
          ease: "power1.out",
          repeat: -1,
          onRepeat: () => {
            gsap.set(dot, {
              boxShadow: "0 0 0 0 rgba(251,245,232,0.35)",
            });
          },
        });

        gsap.set(dot, {
          boxShadow: "0 0 0 0 rgba(251,245,232,0.35)",
        });
      };

      rows.forEach((row) => {
        ScrollTrigger.create({
          trigger: row,
          start: "top center",
          end: "bottom center",
          onEnter: () => activateRow(row),
          onEnterBack: () => activateRow(row),
        });
      });
    });
  }
});
